import { getSearch } from '../window';

export const getEmail = (): string | undefined => {
  try {
    const params = new URLSearchParams(getSearch().substring(1));
    return params.get('email') || undefined;
  } catch (e) {
    // IE fallback
    const match = getSearch().match(/email=([^&]+)/)?.[1];
    if (match) {
      return decodeURIComponent(match);
    }
    return undefined;
  }
};
